import { render, staticRenderFns } from "./serverstatus.vue?vue&type=template&id=3ce20e85&"
import script from "./serverstatus.vue?vue&type=script&lang=ts&"
export * from "./serverstatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce20e85')) {
      api.createRecord('3ce20e85', component.options)
    } else {
      api.reload('3ce20e85', component.options)
    }
    module.hot.accept("./serverstatus.vue?vue&type=template&id=3ce20e85&", function () {
      api.rerender('3ce20e85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverstatus.vue"
export default component.exports